// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeleteEmployeeAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeleteEmployeeAdvanceResponseDados = string;

export type Payroll_DeleteEmployeeAdvanceResponse = ApiResponse<Payroll_DeleteEmployeeAdvanceResponseDados>;

registerResponseContract('Payroll_DeleteEmployeeAdvanceResponse', {})
